<template>
	<div class="order-page">
		<div class="order-header__menu">
			<button
			 class="button--no order-button--active-order"
			 :class="{'order-button--active' : activeButton == 'activeOrder' }"
			 @click="open('activeOrder')"
			>
				<icon
				 name="cart"
				 class="button__icon"
				 size="24px"
				/>
				<span class="button__label">{{resource('activeOrder')}}</span>
			</button>
			<button
			 class="button--no order-button--catalogus"
			 :class="{'order-button--active' : activeButton == 'catalog' }"
			 @click="open('catalog')"
			>
				<icon
				 name="catalog"
				 class="button__icon"
				 size="24px"
				/>
				<span class="button__label">{{resource('catalogus')}}</span>
			</button>
			<button
			 class="button--no order-button--open-orders"
			 :class="{'order-button--active' : activeButton == 'openOrders' }"
			 @click="open('openOrders')"
			>
				<icon
				 name="arrow"
				 class="button__icon"
				 :direction="openOrdersDirection"
				/>
				<span class="button__label">{{resource('openOrders')}}</span>
			</button>
			<router-link
			 to="/add-order"
			 class="button--primary order-button--newOrder"
			>
				<icon
				 name="plus"
				 class="button__icon"
				/>
				<span class="button__label">{{resource('newOrder')}}</span>
			</router-link>
		</div>
		<div
		 class="order-header__info order-info"
		 v-if="order"
		>
			<div class="order-info__client">{{order.client.name}}</div>
			<div class="order-info__location">{{order.client.address.line1}}, {{order.client.address.city}}</div>
			<div class="order-info__quantity">{{orderAmount}}</div>
			<div class="order-info__price">{{total | price}}</div>
			<div class="order-info__delivery-day">{{deliveryDay}}</div>
			<div class="order-info__minimum-order">{{resource('freeOrderAmount')}} {{freeOrderAmount | price}}</div>
		</div>
		<div class="order-content">
			<transition name="delayedFade">
				<div
				 class="orders-list"
				 v-show="showOpenOrders"
				 @click="closeAll()"
				>
					<div
					 class="orders-list__container"
					 @click.stop
					>
						<orderItem
						 class="orders-list__item"
						 :order="order"
						 v-for="order in openOrders"
						 @update="updateOrders(order, $event)"
						 :key="order.key"
						/>
					</div>
				</div>
			</transition>

			<div
			 class="order__content"
			 v-if="order && !syncing"
			>
				<div
				 class="product-list__empty"
				 v-if="cart.length == 0"
				>
					<icon
					 name="scanner"
					 class="product-list__empty-icon"
					 size="250px"
					/>
					<div class="product-list__empty-text">{{resource('startScan')}}</div>
				</div>
				<div
				 class="product-list"
				 v-if="cart.length > 0"
				>
					<div class="product-list__header">
						<div class="product-list__image"></div>
						<div class="product-list__title">{{resource('title')}}</div>
						<div class="product-list__ean">{{resource('ean')}}</div>
						<div class="product-list__brand">{{resource('brand')}}</div>
						<div class="product-list__scan">{{resource('status')}}</div>
						<div class="product-list__orderQty">{{resource('orderQty')}}</div>
						<div class="product-list__price">{{resource('pricePerPiece')}}</div>
						<div class="product-list__amount">{{resource('amount')}}</div>
						<div class="product-list__total">{{resource('total')}}</div>
						<div class="product-list__select">
							<button
							 class="button delete-button"
							 :disabled="selectedList.length == 0"
							 :class="{ 'delete-button--active': selectedList.length > 0 }"
							 @click="removePrompt = true"
							>
								<div
								 class="delete-button__counter"
								 v-if="selectedList.length > 0"
								>{{selectedList.length}}</div>
								<icon name="trash" />
							</button>
						</div>
					</div>
					<DynamicScroller
					 :items="cart"
					 :min-item-size="76"
					 class="product-list__items"
					 key-field="id"
					 id="itemsList"
					 v-if="showList"
					>

						<template v-slot="{ item, index, active }">
							<DynamicScrollerItem
							 :item="item"
							 :active="active"
							 :data-index="index"
							>

								<productItem
								 v-model="item"
								 @update="updateProduct($event, item)"
								 @openSearch="showCatalog = true"
								 @selected="selected($event, item)"
								/>
							</DynamicScrollerItem>
						</template>

					</DynamicScroller>
				</div>

				<searchProduct
				 v-show="showCatalog"
				 @closeSearch="closeAll()"
				 @addProduct="addProduct($event, false)"
				/>
			</div>
			<scanInput @scan="addProduct($event, true)" />
			<div
			 class="remove-popup"
			 v-if="removePrompt"
			>
				<div class="remove-popup__container">
					<div class="remove-popup__title">{{resource('removeOrders')}}</div>
					<div class="remove-popup__text">{{areYouSure}}</div>
					<div class="remove-popup__buttons">
						<button
						 class="remove-popup__button-cancel button--cancel"
						 @click="removePrompt = false"
						>{{resource('cancel')}}</button>
						<button
						 class="remove-popup__button-accept button--primary"
						 @click="removeLines()"
						>{{acceptLineRemoval}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import searchProduct from '../components/searchProduct.vue'
import productItem from '../components/app-productItem.vue'
import scanInput from '../components/app-scanInput.vue'
import orderItem from '../components/app-orderItem.vue'
import beep from '@/../public/media/beep.mp3'
import alert from '@/../public/media/alert.mp3'

var beepSound = new Audio(beep)
var alertSound = new Audio(alert)

export default {
	name: 'order',
	components: {
		searchProduct,
		productItem,
		scanInput,
		orderItem
	},
	created() {
		// check if order id exists, else go to add order and make a valid one
		if (this.$store.getters.orderById(this.$route.params.orderId)) {
			this.$store.commit('setActiveOrder', this.$route.params.orderId)
		} else {
			this.$router.push({ name: 'AddOrder' })
		}
	},
	mounted() {},
	computed: {
		syncing(){
			return this.$store.getters.syncing
		},
		deliveryDay() {
			let lang = this.$store.getters.language
			return this.order.client.content[lang].deliveryDay
		},
		orderAmount() {
			var cartAmount = 0
			for (let i = 0; i < this.cart.length; i++) {
				const item = this.cart[i]
				cartAmount += item.amount
			}
			if (cartAmount === 1) {
				return `${cartAmount} ${this.resource('product')}`
			} else {
				return `${cartAmount} ${this.resource('products')}`
			}
		},
		areYouSure() {
			var amount = this.selectedList.length
			var lang = this.$store.getters.language
			if (amount > 1) {
				if (lang === 'nl') {
					return `Weet je zeker dat je ${amount} orderregels wilt verwijderen?`
				}
				if (lang === 'fr') {
					return `Êtes-vous sûr de vouloir supprimer ${amount} lignes de commande?`
				}
			} else {
				if (lang === 'nl') {
					return `Weet je zeker dat je ${amount} orderregel wilt verwijderen?`
				}
				if (lang === 'fr') {
					return `Êtes-vous sûr de vouloir supprimer ${amount} ligne de commande?`
				}
			}
		},
		acceptLineRemoval() {
			var amount = this.selectedList.length
			var lang = this.$store.getters.language
			if (amount > 1) {
				if (lang === 'nl') {
					return 'Verwijder orderregels'
				}
				if (lang === 'fr') {
					return 'Supprimer les lignes de commande'
				}
			} else {
				if (lang === 'nl') {
					return 'Verwijder orderregel'
				}
				if (lang === 'fr') {
					return 'Supprimer la ligne de commande'
				}
			}
		},
		order() {
			return this.$store.getters.order
		},
		cart: {
			get() {
				if (this.$store.getters.cart) {
					return this.$store.getters.cart
				} else {
					return ''
				}
			},
			set(newVal) {
				// make array
				var newCart = []
				for (var i in newVal) {
					newCart.push(newVal[i])
				}
				this.$store.commit('updateCart', newCart)
			}
		},
		openOrders() {
			return this.$store.getters.getOrderList
		},
		total() {
			var cart = this.$store.getters.cart
			var price = 0
			for (let i = 0; i < cart.length; i++) {
				price = cart[i].amount * cart[i].price.amount + price
			}
			if (isNaN(price) || price === 0) {
				return { currency: 'EUR', amount: 0 }
			} else {
				return { currency: cart[0].price.currency, amount: price }
			}
		},
		freeOrderAmount() {
			var amount = this.order.client.freeOrderAmount
			return { currency: 'EUR', amount: amount }
		},
		openOrdersDirection() {
			if (this.showOpenOrders) {
				return 'up'
			} else {
				return 'down'
			}
		}
	},
	watch: {
		order: {
			handler(newVal) {
				let activeOrder = this.$store.state.app.activeOrder
				// there is always 1 order, the last order is always the active one
				if (!newVal && !activeOrder) {
					// make a new order if there is no active order (so no orders) and if the object is not a order object
					this.$router.push({ name: 'AddOrder' })
				} else {
					if (activeOrder) {
						// if the routerpath doesnt match with the active order id, route to the active order.
						if (
							this.$router.history.current.params.orderId !==
							activeOrder
						) {
							let activeOrderObject = this.$store.getters.orderById(
								activeOrder
							)
							this.$router.push({
								name: 'order',
								params: {
									orderId: activeOrderObject.id,
									order: activeOrderObject
								}
							})
						}
					}
				}
			},
			deep: true
		}
	},
	methods: {
		resource(item) {
			var lang = this.$store.getters.language
			return this.res[lang][item]
		},
		open(target) {
			this.showList = false
			if (target === 'openOrders') {
				if (this.showOpenOrders) {
					this.closeAll()
				} else {
					this.closeAll()
					this.showOpenOrders = true
					this.activeButton = target
				}
			}
			if (target === 'catalog') {
				this.closeAll()
				this.showCatalog = true
				this.activeButton = target
			}
			if (target === 'activeOrder') {
				this.closeAll()
			}

			this.$nextTick(() => {
				this.showList = true
			})
		},
		closeAll() {
			this.activeButton = 'activeOrder'
			this.showOpenOrders = false
			this.showCatalog = false
		},
		updateOrders(order, event) {
			if (event === 'select') {
				this.$store.commit('setActiveOrder', order.id)
				this.closeAll()
			} else if (event === 'delete') {
				let activeOrder = this.$store.state.app.activeOrder
				this.$store.commit('removeOrder', order.id)
				this.closeAll()

				// if the list is empty make a new order
				if (this.$store.getters.getOrderList.length < 1) {
					this.$router.push({ name: 'AddOrder' })
				} else if (order.id === activeOrder) {
					// if the deleted order was active set the next order active
					this.$store.commit(
						'setActiveOrder',
						this.$store.getters.getOrderList[0].id
					)
				}
			}
		},
		activeOrder(id) {
			if (this.$store.state.app.activeOrder === id) {
				return true
			} else {
				return false
			}
		},
		addProduct(input, close) {
			var catalogProduct
			var ean
			if (close) {
				this.closeAll()
			}

			if (typeof input === 'object') {
				catalogProduct = input
				ean = input.ean
			} else {
				ean = input
			}
			var result = this.$store.getters.product(ean)

			if (result) {
				if (result.replacedBy === null) {
					// valid product
					var newProduct = Object.assign({}, result)

					let productInCart = Object.assign(
						{},
						this.$store.getters.productInOrder(newProduct.id)
					)
					if (productInCart.id) {
						if (this.$store.state.app.sound) {
							beepSound.playbackRate = 1
							beepSound.play()
						}
						let newAmount
						if (catalogProduct) {
							newAmount =
								productInCart.amount + newProduct.amount
						} else {
							newAmount =
								productInCart.amount + newProduct.orderQuantity
						}
						this.updateProduct(newAmount, newProduct)
					} else {
						if (this.$store.state.app.sound) {
							beepSound.playbackRate = 0.4
							beepSound.play()
						}
						if (!catalogProduct) {
							newProduct.amount = newProduct.orderQuantity
						}
						newProduct.scan = 'ok'
						this.cart.unshift(newProduct)
						this.cart = Object.assign({}, this.cart)
					}
				} else {
					// replacement product
					if (this.$store.state.app.sound) {
						alertSound.play()
					}
					var replaceProduct = this.$store.getters.productById(
						result.replacedBy
					)
					let productInCart = this.$store.getters.productInOrder(
						replaceProduct.id
					)

					if (productInCart) {
						// if replaced product already exists in cart, the amount just gets added this product
						let newAmount =
							productInCart.amount + replaceProduct.orderQuantity
						this.updateProduct(newAmount, replaceProduct)
					} else {
						// if replaced product does not exists in cart, product gets added with replaced status
						replaceProduct.amount = replaceProduct.orderQuantity
						replaceProduct.scan = 'replace'
						replaceProduct.replaces = ean
						this.cart.unshift(replaceProduct)
						this.cart = Object.assign({}, this.cart)
					}
				}
			} else {
				// invalid product
				if (this.$store.state.app.sound) {
					alertSound.play()
				}

				var errorProduct = {
					id: this.uuidv4(),
					scan: 'error',
					ean: ean,
					amount: 0,
					price: {
						amount: 0,
						currency: 'EUR'
					}
				}
				this.cart.unshift(errorProduct)
				this.cart = Object.assign({}, this.cart)
			}
		},
		updateProduct(type, product) {
			if (type !== 'delete') {
				var productIndex = this.cart.findIndex(item => {
					return item.id === product.id
				})
				/// whole product needs to get updated to maintain reactivity
				let newProduct = Object.assign({}, this.cart[productIndex])
				newProduct.amount = type
				this.$set(this.cart, productIndex, newProduct)
			} else {
				this.showList = false
				let target = this.cart.findIndex(item => {
					return item.id === product.id
				})

				// this is done weirdly because with $delete() the computed cart set() isn't triggered...
				let tempCart = Object.assign([], this.cart)
				tempCart.splice(target, 1)
				this.$set(this, 'cart', tempCart)

				this.$nextTick(() => {
					this.showList = true
				})
			}
		},
		uuidv4() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(
				/[xy]/g,
				function(c) {
					var r = (Math.random() * 16) | 0
					var v = c === 'x' ? r : (r & 0x3) | 0x8
					return v.toString(16)
				}
			)
		},
		selected(event, product) {
			var item = this.selectedList.findIndex(item => {
				return item.id === product.id
			})
			if (item >= 0) {
				this.selectedList.splice(item, 1)
			} else {
				if (event) {
					this.selectedList.push({ selected: true, id: product.id })
				}
			}
		},
		removeLines() {
			var event = new Event('uncheckProducts')
			document.dispatchEvent(event)

			this.selectedList.forEach(line => {
				this.updateProduct('delete', line)
			})
			this.selectedList = []
			this.removePrompt = false
		}
	},
	data() {
		return {
			showList: true,
			scan: '',
			showOpenOrders: false,
			showCatalog: false,
			activeButton: 'activeOrder',
			selectedList: [],
			removePrompt: false,
			res: {
				nl: {
					activeOrder: 'Actieve order',
					openOrders: 'Open orders',
					startDateOrder: 'Order gestart op:',
					catalog: 'Catalogus',
					newOrder: 'Nieuwe order',
					products: 'artikelen',
					product: 'artikel',
					findReplacementProduct: 'Zoek vervangend artikel',
					catalogus: 'Catalogus',
					title: 'Titel',
					ean: 'EAN',
					brand: 'Merk',
					status: 'Status',
					orderQty: 'BE',
					pricePerPiece: 'Prijs p/s',
					amount: 'Aantal',
					total: 'Totaal',
					startScan: 'Start met scannen',
					freeOrderAmount: 'Min: ',
					removeOrders: 'Orderregels verwijderen',
					cancel: 'Annuleer'
				},
				fr: {
					activeOrder: 'Ordre actif',
					openOrders: 'Commandes ouvertes',
					startDateOrder: 'Commande commencée le:',
					catalog: 'Catalogue',
					newOrder: 'Nouvelle commande',
					products: 'articles',
					product: 'article',
					findReplacementProduct:
						'Trouver un article de remplacement',
					catalogus: 'Catalogue',
					title: 'Titre',
					ean: 'EAN',
					brand: 'Marque',
					status: 'Statut',
					orderQty: 'OQ',
					pricePerPiece: 'Price p / p',
					amount: 'Nombre',
					total: 'Total',
					startScan: 'Lancer la numérisation',
					freeOrderAmount: 'Min: ',
					removeOrders: 'Supprimer les lignes',
					cancel: 'Annuler',
					removeLines: 'Supprimer les lignes de commande'
				}
			}
		}
	}
}
</script>

<style lang="scss">
.order-page {
	flex: 1 1 auto;
	display: flex;
	flex-direction: column;
	align-items: stretch;
}
.order-header {
	&__menu {
		display: flex;
		background: $order__header-menu-bg;
		color: $order__header-menu-color;
		padding: 0 $content 0 0;
		height: 58px;
		flex: 0 0 auto;
		.button__label {
			font-size: $fs1;
		}
	}
	&__info {
		flex: 0 0 auto;
		background: $order__header-current-order-bg;
		color: $order__header-current-order-color;
		padding: $content;
	}
}
.order-button {
	&--active-order,
	&--open-orders,
	&--catalogus {
		align-items: stretch;
		padding: $content !important;
		border-radius: 0 !important;
		border-right: 1px solid rgba(0, 0, 0, 0.3) !important;
	}
	&--newOrder {
		align-self: center !important;
		margin-left: auto !important;
	}
	&--active {
		background: $secondary !important;
	}
}
.order-content {
	flex: 1 1 auto;
	position: relative;
	background: $order__container-bg;
	display: flex;
	flex-direction: column;
}
.order__content {
	padding: $content;
	overflow: hidden;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	overflow: hidden;
	flex: 1 1 auto;
}
.product-list {
	border: 1px solid $order__border;
	border-radius: $order__radius;
	background: $order-list__bg;
	display: flex;
	flex-direction: column;
	align-items: stretch;
	max-height: 75vh;
	> *:first-child {
		border-top-left-radius: inherit;
		border-top-right-radius: inherit;
	}
	> *:last-child {
		border-bottom-left-radius: inherit;
		border-bottom-right-radius: inherit;
	}
	> * + * {
		border-top: 1px solid $order__border;
	}
	&__empty {
		flex: 1 1 auto;
		display: flex;
		align-items: center;
		justify-content: center;
		flex-direction: column;
		color: $order__empty-color;
		&-text {
			font-size: 36px;
			font-weight: bold;
			margin-top: $container;
		}
	}
	&__header {
		height: 62px;
		padding: $content;
		display: grid;
		grid-template-columns: 60px 1fr 120px 70px 70px 30px 70px 130px 60px 40px;
		grid-gap: $content;
		align-items: center;
		background: $order-list__header-bg;
		color: $order-list__header-color;
		flex: 0 0 auto;
	}
	&__items {
		overflow: auto;
		flex: 1 1 auto;
	}
}
.order-info {
	display: flex;
	line-height: 0.9em;
	> * {
		align-items: center;
		display: flex;
	}
	> * + * {
		margin-left: $content;
		padding-left: $content;
		border-left: 1px solid rgba(255, 255, 255, 0.35);
	}
	&__client {
		font-weight: bold;
		white-space: pre-wrap;
	}
}
.orders-list {
	position: absolute;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	z-index: 1;
	background: $order-list__overlay;
	&__container {
		background: $order-list__bg;
		color: $order-list__color;
	}
}
.delete-button {
	position: relative;
	&__counter {
		position: absolute;
		right: -$component;
		top: -$component;
		width: 20px;
		height: 20px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-radius: 100%;
		font-size: $fs-1;
		background: $order-list__delete-button-counter-bg;
		color: $order-list__delete-button-counter-color;
	}
	&--active {
		background: $order-list__delete-button-bg;
		color: $order-list__delete-button-color;
	}
}
.remove-popup {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: $overlay;
	color: $text;
	display: flex;
	justify-content: center;
	align-items: center;
	&__container {
		background: $overlay__bg;
		text-align: center;
		padding: $container;
	}
	&__title {
		font-weight: bold;
		font-size: $fs1;
	}
	&__text {
		margin: $content 0;
	}
	&__buttons * + * {
		margin-left: $content;
	}
	&__button-accept,
	&__button-cancel {
		padding: $content/2 $container/2 !important;
	}
}
</style>
